module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/assessment-details-view/assessment-details-view.component.css
// module id = ./src/app/admin/assessment-details-view/assessment-details-view.component.css
// module chunks = main